import axios from "axios";
import { SweetAlertShow } from "../pages/master/Master";
import { api } from "./api";

const metaApi = axios.create({
  baseURL: "https://metawhatsapp.billbazaar.in/api/",
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

metaApi.interceptors.request.use(
  (config) => {
    const business = JSON.parse(localStorage.getItem("setting") ?? "{}");
    const token = business?.meta_wa_api_token;

    if (!token) {
      SweetAlertShow(
        "error",
        "401 Unauthorized",
        "Meta API token verification failed.",
      );
      return Promise.reject("Meta API token missing");
    }
    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const messagesList = async (addUrl = ``) => {
  return await api.get(`/messages/list?${addUrl}`);
};

export const messagesAdd = async (data) => {
  return await api.post(`/messages/add`, data);
};

export const studentAppShare = async () => {
  return await api.get(`/student/app/share`);
};

export const getAllMobileNos = async (addUrl = ``) => {
  return await api.get(`/get-all-mobile-nos?${addUrl}`);
};

export const changePushNotificationStatus = async (id) => {
  return await api.post(`/messages/change-push-notification-status`, { id });
};

export const changeMetaWhatsappStatus = async (id) => {
  return await api.post(`/messages/change-meta-whatsapp-status`, { id });
};

export const updatePushNotification = async (data) => {
  return await api.post(`/messages/update-push-notification`, data);
};

export const updateMetaWhatsapp = async (data) => {
  return await api.post(`/messages/update-meta-whatsapp`, data);
};

export const metaMessageTemplates = async (addUrl = ``) => {
  return await metaApi.get(`/meta/message/templates?${addUrl}`);
};
export const metaMessageTemplateCreate = async (data) => {
  return await metaApi.post("/meta/message/templates/create", data);
};

export const metaMessageTemplateUploadMedia = async (formData) => {
  return await metaApi.post("/meta/message/templates/upload-media", formData);
};

export const metaMessageSend = async (data) => {
  return await metaApi.post(`/meta/message/send`, data);
};

export const metaMessageHistory = async (addUrl = ``) => {
  return await metaApi.get(`/meta/message/history?${addUrl}`);
};

export const metaWallet = async (addUrl = ``) => {
  return await metaApi.get(`/meta/wallet?${addUrl}`);
};

export const SendPushNotification = async (data) => {
  return await api.post(`/send/push/notification `, data);
};

export const changeVoiceNotificationStatus = async (id) => {
  return await api.post(`/messages/change-voice-notification-status`, { id });
};
